const selectedNodeResolver = {
  id: "selectedNode",
  resolve: (_, __, editor) => {
    var _a, _b;
    const node = (_b = (_a = editor == null ? void 0 : editor.state) == null ? void 0 : _a.selection) == null ? void 0 : _b.node;
    if (node) {
      return node;
    } else {
      return void 0;
    }
  }
};
const getVisibleOnlyOnDesktopResolver = (isMobile) => ({
  id: "VISIBLE_ONLY_ON_DESKTOP",
  resolve: () => !isMobile
});

export { getVisibleOnlyOnDesktopResolver, selectedNodeResolver };
//# sourceMappingURL=contentResolvers.js.map
